import {
  HTTP_GETBUDGETCOMPDBYBRAND_FETCHING,
  HTTP_GETBUDGETCOMPDBYBRAND_SUCCESS,
  HTTP_GETBUDGETCOMPDBYBRAND_FAILED,
  HTTP_RESET_GETBUDGETCOMPDBYBRAND,
} from "src/Constants";

const initialState = {
  result: [],
  isFetching: false,
  isError: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case HTTP_GETBUDGETCOMPDBYBRAND_FETCHING:
      return {
        ...state,
        result: [],
        isFetching: true,
        isError: false,
      };
    case HTTP_GETBUDGETCOMPDBYBRAND_SUCCESS:
      return {
        ...state,
        result: payload,
        isFetching: false,
        isError: false,
      };
    case HTTP_GETBUDGETCOMPDBYBRAND_FAILED:
      return {
        ...state,
        result: [],
        isFetching: false,
        isError: true,
      };
    default:
      return state;
  }
};
